import { Progress } from "@ecco/ui/progress";
import PaymentMessage from "./PaymentMessage";
import type { IPaymentMessage } from "./PaymentMessage";

export function PaymentMessageWithLoading(paymentMessage: IPaymentMessage) {
    return (
        <>
            <PaymentMessage
                message={paymentMessage.message}
                color={paymentMessage.color}
                mb={paymentMessage.mb}
                mt={paymentMessage.mt}
            />
            <Progress variant="checkout" isIndeterminate />
        </>
    );
}
PaymentMessageWithLoading.displayName = "PaymentMessageWithLoading";
export default PaymentMessageWithLoading;
